import { useMutation } from '@apollo/client';
import {
  DEACTIVATE_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION,
  GET_PUSH_NOTIFICATION_CAPABILITY_QUERY,
} from 'src/graphql/entities/push-notification/push-notification.operations';

type DeactivatePushNotificationSubscriptionMutation = {
  deactivatePushNotificationSubscription: {
    success: boolean;
  };
};

export const useDeactivatePushNotificationSubscription = () => {
  const [mutate, { loading }] = useMutation<
    DeactivatePushNotificationSubscriptionMutation,
    { endpoint: string }
  >(DEACTIVATE_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION, {
    refetchQueries: [GET_PUSH_NOTIFICATION_CAPABILITY_QUERY],
  });

  return {
    deactivatePushNotificationSubscription: (endpoint: string) =>
      mutate({ variables: { endpoint } }),
    loading,
  };
};
